"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseAttributes = ['uid', 'photos', 'categories', 'universes', 'title', 'description', 'location', 'state', 'shippingSize', 'shippingOptions', 'price', 'brand'];
const dimensionAttributes = ['depth', 'height', 'width', 'precision'];
exports.tableCategoryDefinition = {
    name: 'table',
    attributes: [...dimensionAttributes, 'removable', 'canHelp', 'colors'],
    deliveryUsesFloor: true,
};
exports.storageCategoryDefinition = {
    name: 'storage',
    attributes: [...dimensionAttributes, 'removable', 'canHelp', 'colors', 'furnitureLayout'],
    deliveryUsesFloor: true,
};
exports.seatCategoryDefinition = {
    name: 'seat',
    attributes: [...dimensionAttributes, 'numberOfItems', 'removable', 'canHelp', 'colors'],
    deliveryUsesFloor: true,
};
exports.sofaCategoryDefinition = {
    name: 'sofa',
    attributes: [...dimensionAttributes, 'numberOfSeats', 'removable', 'canHelp', 'colors'],
    deliveryUsesFloor: true,
};
exports.bedCategoryDefinition = {
    name: 'bed',
    attributes: [...dimensionAttributes, 'removable', 'canHelp', 'colors'],
    deliveryUsesFloor: true,
};
exports.appliancesCategoryDefinition = {
    name: 'appliances',
    attributes: ['warranty', ...dimensionAttributes, 'canHelp', 'colors'],
    deliveryUsesFloor: true,
};
exports.smallAppliancesCategoryDefinition = {
    name: 'small-appliances',
    attributes: ['warranty', 'colors'],
    deliveryUsesFloor: false,
};
exports.electronicsCategoryDefinition = {
    name: 'electronics',
    attributes: ['warranty', 'colors'],
    deliveryUsesFloor: false,
};
exports.babyCategoryDefinition = {
    name: 'baby',
    attributes: ['colors'],
    deliveryUsesFloor: false,
};
exports.decorationCategoryDefinition = {
    name: 'decoration',
    attributes: ['colors'],
    deliveryUsesFloor: false,
};
exports.lightsCategoryDefinition = {
    name: 'lights',
    attributes: ['colors'],
    deliveryUsesFloor: false,
};
exports.leisureCategoryDefinition = {
    name: 'leisure',
    attributes: [],
    deliveryUsesFloor: false,
};
exports.categoryDefinitions = [
    exports.tableCategoryDefinition,
    exports.storageCategoryDefinition,
    exports.seatCategoryDefinition,
    exports.sofaCategoryDefinition,
    exports.bedCategoryDefinition,
    exports.appliancesCategoryDefinition,
    exports.smallAppliancesCategoryDefinition,
    exports.electronicsCategoryDefinition,
    exports.babyCategoryDefinition,
    exports.decorationCategoryDefinition,
    exports.lightsCategoryDefinition,
    exports.leisureCategoryDefinition,
];
exports.getAllAttributesFromCategories = (cats) => {
    return cats
        .map((c) => {
        const theDef = exports.categoryDefinitions.find(def => def.name === c);
        return [...baseAttributes, ...((theDef === null || theDef === void 0 ? void 0 : theDef.attributes) || [])];
    })
        .reduce((attributesAcc, catAttributes) => (new Set([...attributesAcc, ...catAttributes])), new Set());
};
exports.requiresFloorForDelivery = (cats) => {
    return cats.map((c) => {
        const theDef = exports.categoryDefinitions.find(def => def.name === c);
        return theDef ? theDef.deliveryUsesFloor : false;
    }).reduce((result, value) => result || value, false);
};
//# sourceMappingURL=index.js.map